import { render, staticRenderFns } from "./RequestLetterTaghirModatSepordeh.vue?vue&type=template&id=fa46a178&scoped=true&"
import script from "./RequestLetterTaghirModatSepordeh.vue?vue&type=script&lang=js&"
export * from "./RequestLetterTaghirModatSepordeh.vue?vue&type=script&lang=js&"
import style0 from "./RequestLetterTaghirModatSepordeh.vue?vue&type=style&index=0&id=fa46a178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa46a178",
  null
  
)

export default component.exports